import { Button } from "reactstrap";
import styled from "styled-components";

const StepperNumber = styled.div.attrs({
  className: "d-flex justify-content-center align-items-center rounded-circle",
})`
  width: 35px;
  height: 35px;
  background: #7b7b8466;
  &.completed {
    background: #028a0f;
    color: white;
  }
`;

const StepperConnector = styled.div`
  width: 2px;
  background: #e1e1e1;
  height: 50px;
  &.completed {
    background: #028a0f;
  }
`;

const IconContainer = styled.div.attrs({
  className: "rounded-1 fs-6 pointer",
})`
  background: #d9d9d9;
  padding: 4px 12px;

  &.active {
    background: #2c92e6;
    color: white;
  }
`;

const SecondaryButton = styled(Button).attrs({
  className: "rounded-1 fw-bold py-2 border-0",
})`
  background: #666666;
`;

const BannerContainer = styled.div.attrs({
  className:
    "d-flex justify-content-center align-items-center column-gap-3 rounded-1 mt-2",
})`
  background: #fee7b9;
  border: 1px solid #cccccc;
  padding: 13px 0;
`;

const Pill = styled.div.attrs({
  className: "rounded-pill px-2 py-1",
})`
  background: #dddddd;
  color: #666666;
`;

export {
  StepperNumber,
  StepperConnector,
  IconContainer,
  SecondaryButton,
  BannerContainer,
  Pill,
};
